import { right } from "fp-ts/lib/Either";
import Constants, { ConstantsName } from "../../../../../constants/Constants";
import di from "../../../../../di/DependencyInjection";
import callAPI from "../../../fetchCallImplementation";

//TODO implement
const DeleteS3RagDocumentImpl = async (customer: string, document: string): Promise<any> => {

    const baseUrl = di.get<Constants>(ConstantsName).RAG;

    const url = new URL(`${baseUrl}/delete-file/${customer}/${document}`);

    const response = await callAPI(url.toString(), 'DELETE', {});
        
    const reader = response.body?.getReader();

    if (!reader) {
        throw new Error("Readable stream not supported or body is empty.");
    }
    
    let result = '';
    const decoder = new TextDecoder();

    while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        result += decoder.decode(value, { stream: true });
    }

    // Decoding the last chunk
    result += decoder.decode();
    
    return right(result);
}

export default DeleteS3RagDocumentImpl;